export const APP_VERSION_CONFIG_DOCUMENT_ID = 'web';
export const DEVICE_APP_VERSION_STORAGE_KEY = 'classroom_app_device_version';
export const PENDING_APP_VERSION_STORAGE_KEY = 'classroom_app_pending_version';
export const APP_UPDATE_CACHE_BUST_PARAM = 'app_update_ts';
